export default __webpack_public_path__ + "static/media/hero.48cc1657.png";